module.exports = __WEBPACK_EXTERNAL_MODULE__vue_runtime_core__;